import { mapState } from 'vuex'

export default {
  name: 'Footer',
  computed: {
    ...mapState({
      authorized: state => state.auth.authorized
    }),
    hideAside () {
      return !this.authorized
    }
  }
}